import Vue from 'vue'
import Router from 'vue-router'
import App from '@/components/App' // 空
import Body from '@/components/Body' // 头部 尾部
import NotFoundComponent from '@/components/NotFoundComponent' // not found

Vue.use(Router)

export default new Router({
  routes: [
    // 首页
    {
      path: '/',
      name: '/',
      component: Body,
      redirect: '/home',
      children: [
        // 首页
        {
          path: 'home',
          name: '/home',
          component: resolve => {
            require(['@/views/home/Home.vue'], resolve)
          }
        },
        // 新闻详情
        {
          path: 'details',
          name: '/details',
          meta: {
            title: '新闻详情'
          },
          component: resolve => {
            require(['@/views/Details.vue'], resolve)
          }
        },
        // 列表更多
        {
          path: 'notice',
          name: '/notice',
          meta: {
            title: '列表'
          },
          component: resolve => {
            require(['@/views/NewsList.vue'], resolve)
          }
        },
        // 点播新闻更多
        {
          path: 'newsDemandMore',
          name: '/newsDemandMore',
          meta: {
            title: '中阳新闻'
          },
          component: resolve => {
            require(['@/views/media/NewsDemandMore.vue'], resolve)
          }
        },
        // 点播新闻详情
        {
          path: 'newsDemand',
          name: '/newsDemand',
          meta: {
            title: '中阳新闻'
          },
          component: resolve => {
            require(['@/views/media/NewsDemand.vue'], resolve)
          }
        },
        // 服务
        {
          path: 'service',
          name: '/service',
          meta: {
            title: '服务'
          },
          component: resolve => {
            require(['@/views/home/Service.vue'], resolve)
          }
        },
        // 便民
        {
          path: 'convenience',
          name: '/convenience',
          meta: {
            title: '便民'
          },
          component: resolve => {
            require(['@/views/home/Convenience.vue'], resolve)
          }
        },
        // 电商
        {
          path: 'shopping',
          name: '/shopping',
          meta: {
            title: '电商'
          },
          component: App,
          redirect: '/shopping/list',
          children: [
            // 电商首页
            {
              path: '/shopping/list',
              name: '/shopping/list',
              component: resolve => {
                require(['@/views/home/ShoppingHome.vue'], resolve)
              },
              redirect: '/shopping/home',
              children: [
                // 电商首页
                {
                  path: '/shopping/home',
                  name: '/shopping/home',
                  component: resolve => {
                    require(['@/views/home/Shopping.vue'], resolve)
                  }
                },
                // 美食
                {
                  path: '/shopping/food',
                  name: '/shopping/food',
                  meta: {
                    title: '美食'
                  },
                  component: resolve => {
                    require(['@/views/home/Food.vue'], resolve)
                  }
                },
                // 旅游
                {
                  path: '/shopping/travel',
                  name: '/shopping/travel',
                  meta: {
                    title: '旅游'
                  },
                  component: resolve => {
                    require(['@/views/home/Travel.vue'], resolve)
                  }
                }
              ]
            },
            // 列表更多
            {
              path: '/shopping/notice',
              name: '/shopping/notice',
              meta: {
                title: '列表'
              },
              component: resolve => {
                require(['@/views/NewsList.vue'], resolve)
              }
            }
          ]
        },
        // 汇聚
        {
          path: 'convergence',
          name: '/convergence',
          meta: {
            title: '汇聚'
          },
          component: resolve => {
            require(['@/views/home/Convergence.vue'], resolve)
          }
        },
        // 政务
        {
          path: 'government',
          name: '/government',
          meta: {
            title: '政务'
          },
          component: App,
          redirect: '/government/list',
          children: [
            // 政务首页
            {
              path: '/government/list',
              name: '/government/list',
              component: resolve => {
                require(['@/views/home/Government.vue'], resolve)
              },
              redirect: '/home/ranking',
              children: [
                // 反馈排名
                {
                  path: '/home/ranking',
                  name: '/home/ranking',
                  component: resolve => {
                    require(['@/views/home/Ranking.vue'], resolve)
                  }
                },
                // 民众投诉
                {
                  path: '/home/complaint',
                  name: '/home/complaint',
                  component: resolve => {
                    require(['@/views/home/Complaint.vue'], resolve)
                  }
                },
                // 民众投诉详情
                {
                  path: '/home/complaintdetails',
                  name: '/home/complaintdetails',
                  component: resolve => {
                    require(['@/views/home/ComplaintDetails.vue'], resolve)
                  }
                }
              ]
            },
            // 列表更多
            {
              path: '/home/notice',
              name: '/home/notice',
              meta: {
                title: '列表'
              },
              component: resolve => {
                require(['@/views/NewsList.vue'], resolve)
              }
            },
            // 办事热线更多
            {
              path: '/home/phone',
              name: '/home/phone',
              meta: {
                title: '办事热线'
              },
              component: resolve => {
                require(['@/views/home/PhoneList.vue'], resolve)
              }
            }
          ]
        },
        // 一村一品
        {
          path: 'villageproduct',
          name: '/villageproduct',
          meta: {
            title: '一村一品'
          },
          component: resolve => {
            require(['@/views/home/Villageproduct.vue'], resolve)
          }
        },
        // 小视频
        {
          path: 'video',
          name: '/video',
          meta: {
            title: '小视频'
          },
          component: resolve => {
            require(['@/views/home/Video.vue'], resolve)
          }
        },
        // 视频详情
        {
          path: 'videodetails',
          name: '/videodetails',
          meta: {
            title: '视频详情'
          },
          component: resolve => {
            require(['@/views/home/VideoDetails.vue'], resolve)
          }
        },
        // 直播
        {
          path: 'videoLive',
          name: '/videoLive',
          meta: {
            title: '直播'
          },
          component: resolve => {
            require(['@/views/home/VideoLive.vue'], resolve)
          }
        },
        // 关于我们
        {
          path: 'about',
          name: '/about',
          meta: {
            title: '关于我们',
            path: '/about'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        },
        // 网站声明
        {
          path: 'statement',
          name: '/statement',
          meta: {
            title: '网站声明',
            path: '/statement'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        },
        // 联系我们
        {
          path: 'contact',
          name: '/contact',
          meta: {
            title: '联系我们',
            path: '/contact'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        }
      ]
    },
    // 新闻资讯
    {
      path: '/news',
      name: '/news',
      meta: {
        title: '新闻资讯'
      },
      component: Body,
      redirect: '/news/list',
      children: [
        // 新闻资讯
        {
          path: 'list',
          name: '/news/list',
          component: resolve => {
            require(['@/views/news/News.vue'], resolve)
          }
        },
        // 新闻详情
        {
          path: 'details',
          name: '/news/details',
          meta: {
            title: '新闻详情'
          },
          component: resolve => {
            require(['@/views/Details.vue'], resolve)
          }
        },
        // 关于我们
        {
          path: 'about',
          name: '/news/about',
          meta: {
            title: '关于我们',
            path: '/about'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        },
        // 网站声明
        {
          path: 'statement',
          name: '/news/statement',
          meta: {
            title: '网站声明',
            path: '/statement'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        },
        // 联系我们
        {
          path: 'contact',
          name: '/news/contact',
          meta: {
            title: '联系我们',
            path: '/contact'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        }
      ]
    },
    // 媒体视听
    {
      path: '/media',
      name: '/media',
      meta: {
        title: '媒体视听'
      },
      component: Body,
      redirect: '/media/list',
      children: [
        // 媒体视听
        {
          path: 'list',
          name: '/media/list',
          component: resolve => {
            require(['@/views/media/Media.vue'], resolve)
          }
        },
        // 电视直播
        {
          path: 'tvLive',
          name: '/media/tvLive',
          meta: {
            title: '电视直播'
          },
          component: resolve => {
            require(['@/views/media/TvLive.vue'], resolve)
          }
        },
        // 广播直播
        {
          path: 'audioLive',
          name: '/media/audioLive',
          meta: {
            title: '广播直播'
          },
          component: resolve => {
            require(['@/views/media/AudioLive.vue'], resolve)
          }
        },
        // 报纸
        {
          path: 'newspaper',
          name: '/media/newspaper',
          meta: {
            title: '报纸'
          },
          component: resolve => {
            require(['@/views/media/Newspaper.vue'], resolve)
          }
        },
        // 点播新闻详情
        {
          path: 'newsDemand',
          name: '/media/newsDemand',
          meta: {
            title: '中阳新闻'
          },
          component: resolve => {
            require(['@/views/media/NewsDemand.vue'], resolve)
          }
        },
        // 影视
        {
          path: 'movie',
          name: '/media/movie',
          meta: {
            title: '影视'
          },
          component: resolve => {
            require(['@/views/media/Movie.vue'], resolve)
          }
        },
        // 音乐
        {
          path: 'music',
          name: '/media/music',
          meta: {
            title: '音乐'
          },
          component: resolve => {
            require(['@/views/media/Music.vue'], resolve)
          }
        },
        // 关于我们
        {
          path: 'about',
          name: '/media/about',
          meta: {
            title: '关于我们',
            path: '/about'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        },
        // 网站声明
        {
          path: 'statement',
          name: '/media/statement',
          meta: {
            title: '网站声明',
            path: '/statement'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        },
        // 联系我们
        {
          path: 'contact',
          name: '/media/contact',
          meta: {
            title: '联系我们',
            path: '/contact'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        }
      ]
    },
    // 生活圈
    {
      path: '/live',
      name: '/live',
      meta: {
        title: '中阳生活'
      },
      component: Body,
      redirect: '/live/list',
      children: [
        // 生活圈
        {
          path: 'list',
          name: '/live/list',
          component: resolve => {
            require(['@/views/live/Live.vue'], resolve)
          },
          redirect: '/live/circle',
          children: [
            // 生活圈列表
            {
              path: '/live/circle',
              name: '/live/circle',
              meta: {
                path: "/live/circle"
              },
              component: resolve => {
                require(['@/views/live/Circle.vue'], resolve)
              }
            },
            // 生活圈详情
            {
              path: '/live/circledetails',
              name: '/live/circledetails',
              meta: {
                path: "/live/circle"
              },
              component: resolve => {
                require(['@/views/live/CircleDetails.vue'], resolve)
              }
            },
            // 有活动我参加
            {
              path: '/live/activity',
              name: '/live/activity',
              meta: {
                path: "/live/activity"
              },
              component: resolve => {
                require(['@/views/live/Activity.vue'], resolve)
              }
            },
            // 有活动我参加内容
            {
              path: '/live/activitydetails',
              name: '/live/activitydetails',
              meta: {
                path: "/live/activity"
              },
              component: resolve => {
                require(['@/views/live/ActivityDetails.vue'], resolve)
              }
            },
            // 同城生活
            {
              path: '/live/citylife',
              name: '/live/citylife',
              meta: {
                path: "/live/citylife"
              },
              component: resolve => {
                require(['@/views/live/City.vue'], resolve)
              },
              redirect: '/live/notice',
              children: [
                // 信息公告
                {
                  path: '/live/notice',
                  name: '/live/notice',
                  meta: {
                    path: "/live/citylife",
                    name: '/live/notice'
                  },
                  component: resolve => {
                    require(['@/views/live/Notice.vue'], resolve)
                  }
                },
                // 信息公告详情
                {
                  path: '/live/noticedetails',
                  name: '/live/noticedetails',
                  meta: {
                    path: "/live/citylife",
                    name: '/live/notice'
                  },
                  component: resolve => {
                    require(['@/views/live/NoticeDetails.vue'], resolve)
                  }
                },
                // 求职招聘
                {
                  path: '/live/work',
                  name: '/live/work',
                  meta: {
                    path: "/live/citylife",
                    name: '/live/work'
                  },
                  component: resolve => {
                    require(['@/views/live/Work.vue'], resolve)
                  }
                },
                // 求职招聘详情
                {
                  path: '/live/workdetails',
                  name: '/live/workdetails',
                  meta: {
                    path: "/live/citylife",
                    name: '/live/work'
                  },
                  component: resolve => {
                    require(['@/views/live/WorkDetails.vue'], resolve)
                  }
                },
                // 生意转让
                {
                  path: '/live/business',
                  name: '/live/business',
                  meta: {
                    path: "/live/citylife",
                    name: '/live/business'
                  },
                  component: resolve => {
                    require(['@/views/live/Work.vue'], resolve)
                  }
                },
                // 生意转让详情
                {
                  path: '/live/businessdetails',
                  name: '/live/businessdetails',
                  meta: {
                    path: "/live/citylife",
                    name: '/live/business'
                  },
                  component: resolve => {
                    require(['@/views/live/WorkDetails.vue'], resolve)
                  }
                }
              ]
            }
          ]
        },
        // 新闻详情
        {
          path: 'details',
          name: '/live/details',
          meta: {
            title: '新闻详情'
          },
          component: resolve => {
            require(['@/views/Details.vue'], resolve)
          }
        },
        // 关于我们
        {
          path: 'about',
          name: '/live/about',
          meta: {
            title: '关于我们',
            path: '/about'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        },
        // 网站声明
        {
          path: 'statement',
          name: '/live/statement',
          meta: {
            title: '网站声明',
            path: '/statement'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        },
        // 联系我们
        {
          path: 'contact',
          name: '/live/contact',
          meta: {
            title: '联系我们',
            path: '/contact'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        }
      ]
    },
    // 乡镇机关
    {
      path: '/country',
      name: '/country',
      meta: {
        title: '乡镇机关'
      },
      component: Body,
      redirect: '/country/list',
      children: [
        // 乡镇机关
        {
          path: 'list',
          name: '/country/list',
          component: resolve => {
            require(['@/views/country/Country.vue'], resolve)
          }
        },
        // 乡镇详情
        {
          path: 'villageDetails',
          name: '/country/villageDetails',
          meta: {
            title: '乡镇详情'
          },
          component: resolve => {
            require(['@/views/country/Details.vue'], resolve)
          }
        },
        // 机关详情
        {
          path: 'officeDetails',
          name: '/country/officeDetails',
          meta: {
            title: '机关详情'
          },
          component: resolve => {
            require(['@/views/country/Details.vue'], resolve)
          }
        },
        // 企业详情
        {
          path: 'businessDetails',
          name: '/country/businessDetails',
          meta: {
            title: '企业详情'
          },
          component: resolve => {
            require(['@/views/country/Details.vue'], resolve)
          }
        },
        // 新闻详情
        {
          path: 'details',
          name: '/country/details',
          meta: {
            title: '新闻详情'
          },
          component: resolve => {
            require(['@/views/Details.vue'], resolve)
          }
        },
        // 关于我们
        {
          path: 'about',
          name: '/country/about',
          meta: {
            title: '关于我们',
            path: '/about'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        },
        // 网站声明
        {
          path: 'statement',
          name: '/country/statement',
          meta: {
            title: '网站声明',
            path: '/statement'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        },
        // 联系我们
        {
          path: 'contact',
          name: '/country/contact',
          meta: {
            title: '联系我们',
            path: '/contact'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        }
      ]
    },
    // 个人中心
    {
      path: '/my',
      name: '/my',
      meta: {
        title: '个人中心',
        auth: true // 加上这个表示需要判断路由--用户登录跳转
      },
      component: Body,
      redirect: '/my/list',
      children: [
        // 个人中心
        {
          path: 'list',
          name: '/my/list',
          component: resolve => {
            require(['@/views/my/My.vue'], resolve)
          },
          redirect: '/my/info',
          children: [
            // 基本信息
            {
              path: '/my/info',
              name: '/my/info',
              meta: {
                path: "/my/info"
              },
              component: resolve => {
                require(['@/views/my/Info.vue'], resolve)
              }
            },
            // 我的评论
            {
              path: '/my/comment',
              name: '/my/comment',
              meta: {
                path: "/my/comment"
              },
              component: resolve => {
                require(['@/views/my/Comment.vue'], resolve)
              }
            },
            // 我的收藏
            {
              path: '/my/collect',
              name: '/my/collect',
              meta: {
                path: "/my/collect"
              },
              component: resolve => {
                require(['@/views/my/Collect.vue'], resolve)
              }
            },
            // 意见反馈
            {
              path: '/my/opinion',
              name: '/my/opinion',
              meta: {
                path: "/my/opinion"
              },
              component: resolve => {
                require(['@/views/my/Opinion.vue'], resolve)
              }
            },
            // 我的订阅
            {
              path: '/my/read',
              name: '/my/read',
              meta: {
                path: "/my/read"
              },
              component: resolve => {
                require(['@/views/my/Read.vue'], resolve)
              }
            },
            // 我的积分
            {
              path: '/my/integral',
              name: '/my/integral',
              meta: {
                path: "/my/integral"
              },
              component: resolve => {
                require(['@/views/my/Integral.vue'], resolve)
              },
              redirect: '/my/shopping',
              children: [
                // 积分商城
                {
                  path: '/my/shopping',
                  name: '/my/shopping',
                  meta: {
                    path: "/my/shopping"
                  },
                  component: resolve => {
                    require(['@/views/my/Shopping.vue'], resolve)
                  }
                },
                // 积分抽奖
                {
                  path: '/my/luckdraw',
                  name: '/my/luckdraw',
                  meta: {
                    path: "/my/luckdraw"
                  },
                  component: resolve => {
                    require(['@/views/my/Luckdraw.vue'], resolve)
                  }
                }
              ]
            }
          ]
        },
        // 新闻详情
        {
          path: 'details',
          name: '/my/details',
          meta: {
            title: '新闻详情'
          },
          component: resolve => {
            require(['@/views/Details.vue'], resolve)
          }
        },
        // 关于我们
        {
          path: 'about',
          name: '/my/about',
          meta: {
            title: '关于我们',
            path: '/about'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        },
        // 网站声明
        {
          path: 'statement',
          name: '/my/statement',
          meta: {
            title: '网站声明',
            path: '/statement'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        },
        // 联系我们
        {
          path: 'contact',
          name: '/my/contact',
          meta: {
            title: '联系我们',
            path: '/contact'
          },
          component: resolve => {
            require(['@/views/about/About.vue'], resolve)
          }
        }
      ]
    },
    // not Found
    {
      path: '*',
      component: NotFoundComponent
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js